// extracted by mini-css-extract-plugin
export var section = "_3w-1";
export var topNav = "_3w-0";